import { ProductionOutputParameters, ProductionOutputPreset, ProductionOutputType } from '@paragon/contract-library';
import { designService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';

import { productionOutputPresetDeleted, productionOutputPresetsLoaded } from '../store/productionOutputPresetsSlice';
import { AsyncThunkActionReturn, AsyncThunkActionVoid } from './thunkActions';

export function loadProductionOutputPresets(): AsyncThunkActionVoid {
  return async function loadProductionOutputPresetsThunkAction(dispatch) {
    try {
      const productionOutputPresets = await designService.productionOutputPresets.getAll();
      dispatch(productionOutputPresetsLoaded(productionOutputPresets));
    } catch (exception) {
      console.error(exception);
      dispatch(enqueueError('Error loading production output presets'));
    }
  };
}

export function createProductionOutputPreset(
  name: string,
  outputTypes: readonly ProductionOutputType[],
  parameters: ProductionOutputParameters,
): AsyncThunkActionReturn<ProductionOutputPreset | undefined> {
  return async function createProductionOutputPresetThunkAction(dispatch) {
    try {
      const productionOutputPreset = await designService.productionOutputPresets.insert(name, outputTypes, parameters);
      dispatch(productionOutputPresetsLoaded([productionOutputPreset]));
      return productionOutputPreset;
    } catch (exception) {
      console.error(exception);
      dispatch(enqueueError('Error creating production output preset'));
    }
  };
}

export function deleteProductionOutputPreset(guid: string): AsyncThunkActionVoid {
  return async function deleteProductionOutputPresetThunkAction(dispatch) {
    try {
      await designService.productionOutputPresets.remove(guid);
      dispatch(productionOutputPresetDeleted(guid));
    } catch (exception) {
      console.error(exception);
      dispatch(enqueueError('Error deleting production output preset'));
    }
  };
}
